module.exports = __webpack_public_path__ + "static/media/support_green.d5d329fd.svg";